<main lottie [options]="lottiParams()" (animationCreated)="handleAnimation($event)"></main>
